import { render, staticRenderFns } from "./Microbiology.vue?vue&type=template&id=6455b742&scoped=true"
import script from "./Microbiology.vue?vue&type=script&lang=js"
export * from "./Microbiology.vue?vue&type=script&lang=js"
import style0 from "./Microbiology.vue?vue&type=style&index=0&id=6455b742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455b742",
  null
  
)

export default component.exports